import React from 'react';
import { getFontOptions, getSelectedOption, mergeCulturalIntoClassic } from './commonRingUtils';
import { ISwatchContent, ITab } from '../types/customizer';
import EngravingNoneTabFilter from '../components/EngravingNoneTabFilter';
import SwatchFilter from '../components/SwatchFilter';
import EngravingFilter from '../components/EngravingFilter';

export const getEngravingItems = (product: any, engraving: any) => {
  if (!engraving) {
    return {};
  }
  const engravingOptions = engraving.types.options || [];
  const SKU_LIST: string[] = engravingOptions.map((item: any) => item.sku);
  const selectedSKU = engravingOptions.find((item: any) => item.selected);
  const obj: {
    isEnabled?: boolean;
    content?: ISwatchContent;
    items?: ITab[];
    selectedItem: string;
    component?: React.ComponentType<any>;
  } = {
    component: undefined,
    content: undefined,
    items: undefined,
    selectedItem: ''
  };
  if (SKU_LIST.includes('NONE')) {
    obj.selectedItem = 'none';
    obj.component = EngravingNoneTabFilter;
    obj.isEnabled = true;
    obj.content = {
      hasSwatch: true,
      fieldType: 'engraving_new',
      options: engravingOptions,
      selectedOption: selectedSKU
    };
  }
  if (SKU_LIST.includes('D') && selectedSKU.sku === 'D') {
    obj.selectedItem = 'pattern';
    obj.items = [
      {
        title: (isActive) => 'Engraving Pattern',
        helzberg_key: '',
        eventKey: 'engraving_none',
        isSelected: selectedSKU?.sku === 'NONE',
        // actionPayload: { engraving_none: 'NONE' },
        isEnabled: true,
        component: EngravingNoneTabFilter,
        content: {
          hasSwatch: true,
          fieldType: 'engraving_new',
          options: engravingOptions,
          selectedOption: selectedSKU,
          hideBorder: true
        }
      },
      {
        title: 'Pattern',
        helzberg_key: 'design_pattern',
        label: 'Engraving Pattern',
        eventKey: 'engraving_pattern',
        // isSelected: selectedSKU?.sku === 'D',
        // actionPayload: { engraving_new: 'D' },
        component: SwatchFilter,
        isEnabled: engraving?.design_patterns?.options?.length > 0,
        content: {
          hasSwatch: true,
          fieldType: 'engraving_pattern',
          options: mergeCulturalIntoClassic(getFontOptions(engraving?.design_patterns?.options || [])),
          selectedOption: getSelectedOption(engraving?.design_patterns?.options)
        }
      }
    ];
  }

  if (SKU_LIST.includes('T') && selectedSKU.sku === 'T') {
    obj.selectedItem = 'text';
    obj.items = [
      {
        title: (isActive) => 'Engraving Text',
        helzberg_key: '',
        eventKey: 'engraving_none',
        isSelected: selectedSKU?.sku === 'NONE',
        // actionPayload: { engraving_none: 'NONE' },
        isEnabled: true,
        component: EngravingNoneTabFilter,
        content: {
          hasSwatch: true,
          fieldType: 'engraving_new',
          options: engravingOptions,
          selectedOption: selectedSKU,
          hideBorder: true
        }
      },
      {
        title: 'Text',
        helzberg_key: 'text',
        label: 'Engraving Font',
        eventKey: 'engraving_text',
        // isSelected: selectedSKU?.sku === 'T',
        component: EngravingFilter,
        // actionPayload: { engraving_new: 'T' },
        isEnabled: engraving?.text?.fonts?.length > 0,
        content: {
          hasSwatch: false,
          fieldType: 'engraving_new',
          options: getFontOptions(engraving?.text?.fonts || []),
          selectedOption: getSelectedOption(engraving?.text?.fonts),
          engravingText: engraving?.text?.text
        }
      }
    ];
  }
  return obj;
};
